// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ab85496","409":"03f4c791","533":"f383ea8e","553":"0af43fd6","666":"b49d8465"}[chunkId] + ".chunk.js";
};